export const fund = {
	totalWrap: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		boxShadow: 'var(--box-shadow--1)',
		marginBottom: '20px',

		'@media (max-width: 1199.98px)': {
			padding: '16px',
		},

		'@media (max-width: 639.98px)': {
			padding: '12px',
		},

		'@media (min-width: 1200px)': {
			boxShadow: 'var(--box-shadow--2)',
		},
	},

	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		minHeight: 'calc(100vh - 148px)',

		'@media (max-width: 639.98px)': {
			padding: '16px 20px 0',
		},
		'@media (min-width: 1200px)': {
			padding: '24px',
			background: 'var(--default-white)',
			borderRadius: '8px',
			boxShadow: 'var(--box-shadow--1)',
			minHeight: 'calc(100vh - 128px)',
			maxHeight: 'fit-content',
		},
	},

	totalLabel: {
		color: 'var(--neutral-300)',
		textAlign: 'center',
		marginBottom: '5px',

		'@media (max-width: 639.98px)': {
			fontSize: '14px',
			lineHeight: '14px',
			marginBottom: '0px',
		},
	},

	totalValue: {
		color: 'var(--primary-700)',
		textAlign: 'center',

		'@media (max-width: 639.98px)': {
			fontSize: '20px',
		},
	},

	fundList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '20px',
		paddingBottom: '80px',

		'@media (max-width: 1199.98px)': {
			gap: '16px',
		},

		'@media (max-width: 639.98px)': {
			gap: '12px',
		},
	},

	popup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		padding: '20px',
		height: '100%',
	},

	drawer: {
		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '972px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 120px',
			},

			'@media (max-width: 639.98px)': {
				padding: '0',
			},
		},
	},

	button: {
		display: 'flex',
		marginTop: 'auto',

		'@media (max-width: 1199.98px)': {
			display: 'none',
		},
	},
};
